import { enterpriseApiSlice } from "./index";
import { HeatmapData } from "../Model/Api/HeatmapObjects";

export const analyticsApi = enterpriseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchHeatmapData: builder.query({
      query: ({ startDate, endDate, timeFrame }) => ({
        url: `/analytics/heat-map/${timeFrame}`,
        method: "GET",
        params: {
          startDate,
          endDate,
        },
      }),
      keepUnusedDataFor: 0,
      extraOptions: { auth: true },
      transformResponse: (response) => new HeatmapData(response),
    }),

    fetchChHeatmapData: builder.query({
      query: ({ startDate, endDate, timeframe, companyIds }) => {
        const params = {
          companyIds: (companyIds ?? []).join(","),
          timeframe,
          orderType: "ALL",
        };
        if (timeframe === "range") {
          params.startDate = startDate;
          params.endDate = endDate;
        }
        return {
          url: `/admin/analytics/ch/heat-map`,
          method: "GET",
          params,
        };
      },
      keepUnusedDataFor: 0,
      extraOptions: { auth: true },
      transformResponse: (response) => new HeatmapData(response),
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetchHeatmapDataQuery,
  useLazyFetchHeatmapDataQuery,
  useFetchChHeatmapDataQuery,
  useLazyFetchChHeatmapDataQuery,
} = analyticsApi;
